const radioButtons = document.querySelectorAll('.custom-variant-picker input[type="radio"]');
const $product = document.querySelector("[data-product-json]");
const product = JSON.parse($product.textContent);
const variants = product.variants;
const variantJsonElement = document.querySelector('script[data-variant-json]');
const variantData = JSON.parse(variantJsonElement.textContent);
const variantOptions = document.querySelectorAll('.variant-option');
const renderVariantDetails = (matchingObject) => {
  const packDrawer = document.querySelector(".pack__drawer");
  packDrawer.innerHTML = "";

  const matchingVariant = variantData.find((obj) => Object.keys(obj)[0] === matchingObject);
  let packItems = null;
  let packContent = [product.title]

  if (matchingVariant) {
    packItems = matchingVariant[matchingObject];

    if (packItems.length > 0) {
      packItems.forEach((subproduct) => {
        const packItemDiv = document.createElement("div");
        packItemDiv.classList.add("pack__item");

        const image = document.createElement("img");
        image.src = subproduct.featured_image;
        image.alt = "";
        image.width = "157";
        image.height = "157";
        image.loading = "lazy";

        const packName = document.createElement("p");
        packName.classList.add("pack__name");
        packName.textContent = subproduct.title;

        const variantPriceDiv = document.createElement("div");
        variantPriceDiv.classList.add("variant__price");

        if (subproduct.compare_at_price > subproduct.price) {
          const comparePrice = document.createElement("s");
          comparePrice.classList.add("price-item", "price-item--regular", "variant-compare");
          comparePrice.textContent = toEuro(subproduct.compare_at_price / 100);
          variantPriceDiv.appendChild(comparePrice);
        }

        const variantPrice = document.createElement("span");
        variantPrice.classList.add("price", "price--end", "variant-price");
        variantPrice.textContent = toEuro(subproduct.price / 100);
        variantPriceDiv.appendChild(variantPrice);

        packItemDiv.appendChild(image);
        packItemDiv.appendChild(packName);
        packItemDiv.appendChild(variantPriceDiv);

        packDrawer.appendChild(packItemDiv);
        packContent.push(subproduct.title);
      });
    }
  }
  let packLength = 0;
  if (packItems != null) {
    packLength = packItems.length;
  }

  const remainingDivs = 3 - packLength;
  let unlockedCount = document.querySelector('.conteo-desbloqueados');
  unlockedCount.innerHTML = packLength;

  for (let i = 0; i < remainingDivs; i++) {
    const lockedPackDiv = document.createElement("div");
    lockedPackDiv.classList.add("locked-pack");

    const lockedName = document.createElement("p");
    lockedName.classList.add("locked-name");
    let packPosition = i + 1;
    if (remainingDivs == 2) packPosition = i + 2;
    if (remainingDivs == 1) packPosition = i + 3;
    lockedName.textContent = `Pack ${packPosition}`;

    const exclusivo = document.createElement("p");
    exclusivo.classList.add("exclusivo");
    exclusivo.textContent = "Exclusivo";

    lockedPackDiv.innerHTML = `
    <svg class="icon icon-padlock" width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9.58366V7.66699C6 4.49491 7 1.91699 12 1.91699C17 1.91699 18 4.49491 18 7.66699V9.58366M12 17.7295C12.663 17.7295 13.2989 17.4771 13.7678 17.0278C14.2366 16.5785 14.5 15.9691 14.5 15.3337C14.5 14.6982 14.2366 14.0889 13.7678 13.6395C13.2989 13.1902 12.663 12.9378 12 12.9378C11.337 12.9378 10.7011 13.1902 10.2322 13.6395C9.76339 14.0889 9.5 14.6982 9.5 15.3337C9.5 15.9691 9.76339 16.5785 10.2322 17.0278C10.7011 17.4771 11.337 17.7295 12 17.7295Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 21.083H7C3 21.083 2 20.1247 2 16.2913V14.3747C2 10.5413 3 9.58301 7 9.58301H17C21 9.58301 22 10.5413 22 14.3747V16.2913C22 20.1247 21 21.083 17 21.083Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
    lockedPackDiv.appendChild(lockedName);
    lockedPackDiv.appendChild(exclusivo);

    packDrawer.appendChild(lockedPackDiv);
  }

   updatePackContents(packContent);
};

const userCurrency = window.Shopify.currency;
const currencySymbol = {
  USD: "$",
  EUR: "€",
  MXN: "$",
};

const compareSymbol = () => {
  return currencySymbol[userCurrency.active] ?? "€";
};

const toEuro = (price) => {
  if (window.Shopify.currency.active == "EUR") {
    return price.toFixed(2) + compareSymbol();
  } else {
    return compareSymbol() + price.toFixed(2);
  }
};

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
}

const toDiscount = (price) => {
  return `${Math.floor(price)}`
};


const updatePackContents = (items) => {
  const packList = document.createElement('ul');
   items.forEach(item => {
     if(item != product.title){
    const packItem = document.createElement('li');
     packItem.textContent = item;
     packList.appendChild(packItem);
   }
   });
const contentAccordion = document.querySelector('.product__info-wrapper .product__accordion .accordion__content');
const existingDiv = contentAccordion.querySelector('.my-existing-div'); // Cambia '.my-existing-div' al selector correcto

  if (contentAccordion) {
    if (existingDiv) {
      // Si el div existente ya existe, actualiza su contenido
      existingDiv.innerHTML = packList.outerHTML; // Reemplaza con tu contenido real
    } else {
      // Si el div no existe, crea un nuevo div y agrega el contenido
      const newDiv = document.createElement('div');
      newDiv.className = 'my-existing-div'; // Asigna la clase adecuada
      newDiv.innerHTML = packList.outerHTML; // Reemplaza con tu contenido real
      contentAccordion.appendChild(newDiv);
    }
  }
}
radioButtons.forEach((button) => {
  optionName = button.dataset.name;
  const optionValue = button.dataset.value;
  const variantName = `${optionValue}`;
  const currentVariant = variants.filter((variant) => variant.title == variantName);
  const variantPrice = currentVariant[0].price / 100;
  const priceIteration = currentVariant[0].compare_at_price - currentVariant[0].price;
  const variantComparePrice = (priceIteration / currentVariant[0].compare_at_price) * 100;
  const available = currentVariant[0].available;

  if (available === false) {
    button.parentNode.parentNode.classList.add("disabled");
  }

  const priceWrapper = document.createElement("div");
  priceWrapper.classList.add("cart-item__price-wrapper");
  const price = document.createElement("span");
  price.classList.add("price", "price--end");

  if (!optionValue.includes('Producto')) {
    price.innerHTML = `<strong>${toDiscount(variantComparePrice)}%</strong> DTO.`;
  }else{
    price.innerHTML = `<strong>${toEuro(variantPrice)}</strong> en total`;
  }

  priceWrapper.appendChild(price);

  button.parentNode.parentNode.querySelector(".price-wrapper").appendChild(priceWrapper);

  button.addEventListener("click", function () {
    const select = document.querySelector(`select[name="options[${optionName}]"]`);
    select.value = optionValue;
    select.dispatchEvent(new Event("change", { bubbles: true }));

    document.querySelectorAll(".variant-option").forEach(function (option) {
      option.classList.remove("active");
    });

    this.parentNode.parentNode.classList.add("active");

    setTimeout(() => {
      const currentSelectedVariant = window.location.href.split("variant=")[1];
      renderVariantDetails(currentSelectedVariant);
    }, 500);
  });
});

variantOptions.forEach(label => label.addEventListener('click', (e) => {
  e.currentTarget.querySelector('input').click();
}));

const productGift = document.querySelector('.product-gift');
// variantOptions.forEach(label => label.addEventListener('change' , (e) => {
//   console.log(e)
//   if (productGift) {
//     setTimeout(() => {
//       label.closest('.product__info-wrapper').querySelector('.product-form__submit').textContent = 'Añadir al carrito + Desbloquear regalo';
//     }, 300);
//   }
// }))

const checkedRadio = document.querySelector('.custom-variant-picker input[type="radio"]:checked');
checkedRadio.parentNode.parentNode.classList.add("active");
// setTimeout(() => {
//   checkedRadio.dispatchEvent(new Event("click", { bubbles: true }));
// }, 200);